var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import AmountInput from '@declaration/components/UI/AmountInput.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import FileCollectionUpload from '@declaration/components/upload/FileCollectionUpload.vue';
import Card from '@declaration/components/UI/Card.vue';
import { ClaimFileType } from '@shared/types/file';
import formatOptionalCentsAmount from '@shared/utils/formatOptionalCentsAmount';
import { ChargeTypology } from '@shared/types/api/charge';
const claim = namespace('claim');
const qualification = namespace('qualification');
let WaterLeakageCauseLocalizedPlumberIntervenedQuestion = class WaterLeakageCauseLocalizedPlumberIntervenedQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.fileType = ClaimFileType.ProfessionalIntervention;
        this.invoiceFileCollection = null;
        this.plumberInvoiceAmount = null;
    }
    get invoice() {
        return this.invoiceFileCollection;
    }
    set invoice(fileCollection) {
        this.invoiceFileCollection = fileCollection;
    }
    get invoiceAmount() {
        return this.plumberInvoiceAmount;
    }
    set invoiceAmount(amount) {
        this.plumberInvoiceAmount = amount;
    }
    get panelTitle() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.panel-title');
    }
    get sidebarTitle() {
        const key = 'step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.question-sidebar_title';
        return this.$te(key) ? this.$t(key) : this.panelTitle;
    }
    get title() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.title');
    }
    get description() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.description');
    }
    get uploadLabel() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.upload-button-label');
    }
    get addFileLabel() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.add-file-label');
    }
    get answer() {
        if (!this.invoice || this.invoiceAmount === null) {
            return null;
        }
        return this.$tc(`step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu/facture.answer`, undefined, {
            amount: formatOptionalCentsAmount(this.invoiceAmount),
        });
    }
    get canValidate() {
        var _a, _b;
        const hasFiles = !!((_b = (_a = this.invoiceFileCollection) === null || _a === void 0 ? void 0 : _a.uploadedAppFiles) === null || _b === void 0 ? void 0 : _b.length);
        const hasAmount = !!this.plumberInvoiceAmount;
        return hasFiles && hasAmount;
    }
    async validate() {
        if (!this.canValidate)
            return;
        if (!this.invoiceFileCollection || this.plumberInvoiceAmount === null)
            return;
        await this.updateAndSaveWaterDamageQualification({
            step: this.step,
            qualificationPayload: {},
        });
        const charge = {
            typology: ChargeTypology.LeakageDetectionFees,
            amount: this.plumberInvoiceAmount,
            invoice: this.invoiceFileCollection,
            description: null,
        };
        await this.updateAndSaveClaim({
            step: this.step,
            claimPayload: {},
            charges: [charge],
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "updateAndSaveClaim", void 0);
__decorate([
    qualification.State('qualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "updateWaterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
WaterLeakageCauseLocalizedPlumberIntervenedQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiButton, FileCollectionUpload, AmountInput, Card },
        props: QuestionProps,
    })
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion);
export default WaterLeakageCauseLocalizedPlumberIntervenedQuestion;
